(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CB-text-column-with-images"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scriptTags = Array.from(document.getElementsByTagName("script"));
    const linkTags = Array.from(document.getElementsByTagName("link"));
    const swiperScriptExists = scriptTags.some(tag => tag.src.includes('swiper'));
    const swiperLinkExists = linkTags.some(tag => tag.href.includes('swiper'));

    if (!swiperScriptExists) {
      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
      document.head.appendChild(swiperScript);
    }
    if (!swiperLinkExists) {
      const swiperLink = document.createElement('link');
      swiperLink.rel = 'stylesheet';
      swiperLink.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
      document.head.appendChild(swiperLink);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
